const translate = {
    "ko":{
        "popup":{
            "acitveAlarm":"알람이 활성화 되었습니다.",
            "inAcitveAlarm":"알람이 비활성화 되었습니다.",
            "IPCopied":"IP주소가 복사 되었습니다.",
            "copyInviteCode":"초대코드가 복사 되었습니다.",
            "copyInviteLink":"초대링크가 복사 되었습니다.",
            "copyInviteQR":"초대QR이 복사 되었습니다.",
            "okxNotFound":"OKX Passphrase를 찾을수없습니다.",
            "invalidAPI":"유효하지 않은 API 키입니다.",
            "alreadyRegAPI":"등록된 API 입니다.",
            "unregisteredUser":"등록되지않은 유저입니다.",
            "unregisteredAPI":"등록되지않은 API입니다.",
            "APIError":"API 수정 중 오류가 발생했습니다. 다시 시도해주세요."
        }
    },
    "en":{
        "popup":{
            "acitveAlarm":"alarm activated.",
            "inAcitveAlarm":"alarm inactivated.",
            "IPCopied":"IP address is copied.",
            "copyInviteCode":"Invitation code is copied.",
            "copyInviteLink":"Invitation link is copied.",
            "copyInviteQR":"Inviation QR is copied.",
            "okxNotFound":"Cannot find OKX Passphrase.",
            "invalidAPI":"Unavailable API key.",
            "alreadyRegAPI":"Already registered API.",
            "unregisteredUser":"Unregistered user.",
            "unregisteredAPI":"Unregistered API.",
            "APIError":"There is an error adjusting API. Please try again."
        }
    },
    "ja":{
        "popup":{
            "acitveAlarm":"アラームを活性化しました。",
            "inAcitveAlarm":"アラームを非活性化しました。",
            "IPCopied":"API連動を活性化しました。",
            "copyInviteCode":"招待コードがコピーされました。",
            "copyInviteLink":"招待リンクをコピーしました。",
            "copyInviteQR":"招待QRコードをコピーしました。",
            "okxNotFound":"OKXパスフレーズが見つかりません。",
            "invalidAPI":"無効なAPIキーです。",
            "alreadyRegAPI":"登録されたAPIです。",
            "unregisteredUser":"登録されていないユーザーです。",
            "unregisteredAPI":"登録されていないAPIです。",
            "APIError":"APIの変更中にエラーが発生しました。もう一度お試しください。"
        }
    },
    "zh":{
        "popup":{
            "acitveAlarm":"信号提示音已启用。",
            "inAcitveAlarm":"信号提示音已禁用 。",
            "IPCopied":"IP地址已复制 。",
            "copyInviteCode":"邀请代码已复制。",
            "copyInviteLink":"邀请链接已复制 。",
            "copyInviteQR":"邀请二维码已复制 。",
            "okxNotFound":"无法查询 OKX Passphrase 。",
            "invalidAPI":"该 API 密钥无效。",
            "alreadyRegAPI":"该 API 密钥已被注册。",
            "unregisteredUser":"未注册的用户。",
            "unregisteredAPI":"未注册的API密钥。",
            "APIError":"更改API密钥时发生错误。 请再试一次。"
        }
    },
    "ru":{
        "popup":{
            "acitveAlarm":"Уведомление активировано.",
            "inAcitveAlarm":"Уведомление отключено.",
            "IPCopied":"IP-адрес скопирован.",
            "copyInviteCode":"Код приглашения скопирован.",
            "copyInviteLink":"Ссылка на приглашение скопирована",
            "copyInviteQR":"QR-приглашение скопировано",
            "okxNotFound":"Не удаётся найти OKX Passphrase.",
            "invalidAPI":"Неверный ключ API.",
            "alreadyRegAPI":"Это зарегистрированный API",
            "unregisteredUser":"Не зарегистрированный пользователь.",
            "unregisteredAPI":"Это незарегистрированный API.",
            "APIError":"Произошла ошибка при изменении API. Пожалуйста, попробуйте еще раз."
        }
    },
    "vi":{
        "popup":{
            "acitveAlarm":"Thông báo được kích hoạt.",
            "inAcitveAlarm":"Thông báo chưa được kích hoạt.",
            "IPCopied":"Đã sao chép địa chỉ IP",
            "copyInviteCode":"Đã sao chép mã giới thiệu.",
            "copyInviteLink":"Đã sao chép link giới thiệu.",
            "copyInviteQR":"Đã sao chép QR giới thiệu.",
            "okxNotFound":"Không tìm thấy cụm mật khẩu OKX.",
            "invalidAPI":"Khóa API không hợp lệ.",
            "alreadyRegAPI":"Đây là một API đã đăng ký.",
            "unregisteredUser":"Người dùng chưa đăng ký.",
            "unregisteredAPI":"Đây là API chưa được đăng ký.",
            "APIError":"Đã xảy ra lỗi khi sửa đổi API. Vui lòng thử lại."
        }
    },
}

export function popupControll(text){
    // console.log('text', text)
    // let msgText = document.querySelector('.messageTxt').innerText;
    let popupMsg = document.querySelector('.popupMessage');
    // console.log('popupMsg', popupMsg)
    if(popupMsg){
        popupMsg.style.display = 'block';
        document.querySelector('.messageTxt').innerText = text;
        setTimeout(()=> {
            popupMsg.style.display = 'none';
        },2000)
    }
}


export function msgControll(word){
    let popupMsg = document.querySelector('.popupMessage');

    // // console.log(popupMsg);
    if (popupMsg) {
        var lang = localStorage.getItem('localeLang') || "en"
        popupMsg.style.display = 'block';
        // document.querySelector('.messageTxt').dataset.content = 'popup'
        // document.querySelector('.messageTxt').innerText = text;
        // document.querySelector('.messageTxt').dataset.word = word;
        document.querySelector('.messageTxt').innerHTML = translate[lang]['popup'][word]
        setTimeout(() => {
            popupMsg.style.display = 'none';
        }, 2000)
    }
}

export function msgEl(){
    // 알람 활성화 비활성화
    let alarmAble = document.querySelectorAll('.btn_alarm_box input[type=checkbox]');
    let allAlarmAble = document.querySelectorAll('.alram_setBox input[type=checkbox]');
    let ipCopy = document.querySelectorAll('.ipcopy');
    let invCode = document.querySelectorAll('.inv_code a[class=copy]');
    let invLink = document.querySelectorAll(".inv_link a[class=copy]")
    let invQR = document.querySelectorAll(".inv_qr a[class=copy]")
    if(alarmAble){
        alarmAble.forEach(function(checkbox) {
            checkbox.addEventListener('change', function() {
                if (this.checked) {
                    msgControll('acitveAlarm');
                } else {
                    msgControll('inAcitveAlarm');
                }
            });
        });
    }
    if(allAlarmAble){
        allAlarmAble.forEach(function(checkbox) {
            checkbox.addEventListener('change', function() {
                if (this.checked) {
                    msgControll('acitveAlarm');
                } else {
                    msgControll('inAcitveAlarm');
                }
            });
        });
    }
    if(ipCopy){
        ipCopy.forEach(function(el) {
            el.addEventListener('click', function() {
                msgControll('IPCopied')
            });
        });
    }
    if(invCode){
        invCode.forEach(function(el) {
            el.addEventListener('click', function() {
                msgControll('copyInviteCode');
            });
        });
    }
    if(invLink){
        invLink.forEach(function(el) {
            el.addEventListener('click', function() {
                msgControll('copyInviteLink');
            });
        });
    }
    if(invQR){
        invQR.forEach(function(el) {
            el.addEventListener('click', function() {
                msgControll('copyInviteQR');
            });
        });
    }
}

export function APIErrorStatus(error){
    if(error.response && error.response.status === 500 && error.response.data && error.response.data.code === 101){
        msgControll('okxNotFound');
    } else if(error.response && error.response.status === 500 && error.response.data && error.response.data.code === 102){
        msgControll('invalidAPI');
    }else if(error.response && error.response.status === 500 && error.response.data && error.response.data.code === 103){
        msgControll('alreadyRegAPI');
    }else if(error.response && error.response.status === 500 && error.response.data && error.response.data.code === 104){
        msgControll('unregisteredUser');
    }else if(error.response && error.response.status === 500 && error.response.data && error.response.data.code === 105){
        msgControll('unregisteredAPI');
    } else {
    // 기타 다른 에러에 대한 처리
        msgControll('APIError');
    }
    return;
}

// alarm > score/vol/rsi 알람
export function msgAlarm() {
    // 알람 활성화 비활성화
    let alarmScore = document.querySelectorAll(
      ".alarmchk_toggle input[type=checkbox]"
    );
    alarmScore.forEach(function (checkbox) {
      checkbox.addEventListener("change", function () {
        if (this.checked) {
          msgControll("acitveAlarm");
        } else {
          msgControll("inAcitveAlarm");
        }
      });
    });
  }